export enum HistoryType {
  DEVICE = 'device',
  USER = 'user',
}
